import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/merchandise/holdProducts.ts
import { Exception } from "@wbk/logger";
var holdProducts = (_0) => __async(void 0, [_0], function* ({ userId, email, products, lang }) {
  var _a;
  try {
    const params = new URLSearchParams({
      user_id: userId,
      email,
      lang
    });
    products.forEach((p, i) => {
      params.append(`products[${i}][product_id]`, p.id.toString());
      params.append(`products[${i}][quantity]`, p.quantity.toString());
    });
    const data = yield fetchClient({
      url: `/webook-shop/hold-products?${params.toString()}`,
      options: {
        method: "POST"
      }
    });
    return data.data;
  } catch (error) {
    const errorData = error == null ? void 0 : error.data;
    throw new Exception({
      error,
      name: "holdProductsException",
      context: { extra: { products }, message: (_a = errorData == null ? void 0 : errorData[0]) == null ? void 0 : _a.message }
    });
  }
});

export {
  holdProducts
};
//# sourceMappingURL=chunk-MPOZWOTP.mjs.map